import gql from 'graphql-tag';

export default gql`
  mutation insertCustomRedirect($groupId: Int!, $fromPath: String!, $toPath: String!, $permanent: Boolean!) {
    insert_custom_redirects_one(object: {
      group_id: $groupId, from_path: $fromPath, to_path: $toPath, permanent: $permanent
    }) {
      id
    }
  }
`;
